import React, { useEffect, useState } from 'react';
import StableMuiDialog from '../../../common/StableMuiDialog.js';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

let openVacateConfirm = null;
let vacateConfirmResolve = null;

export const confirmVacateStip = (rows) => new Promise((resolve) => {
  if (!openVacateConfirm) {
    resolve(false);
    return;
  }
  vacateConfirmResolve = resolve;
  openVacateConfirm(rows);
});

const vacatePhrase = (status) => (
  status === 'NyscefUploaded' ? 'already uploaded to NYSCEF' : 'already countersigned'
);

const VacateStipDialog = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    openVacateConfirm = setRows;
    return () => {
      if (openVacateConfirm === setRows) openVacateConfirm = null;
    };
  }, []);

  const close = (confirmed) => {
    vacateConfirmResolve?.(confirmed);
    vacateConfirmResolve = null;
    setRows(null);
  };

  const list = rows || [];
  const hasCountersigned = list.some((row) => row.status === 'Countersigned');
  const hasUploaded = list.some((row) => row.status === 'NyscefUploaded');
  let statusText = 'already countersigned';
  if (hasUploaded && hasCountersigned) statusText = 'already countersigned or uploaded to NYSCEF';
  else if (hasUploaded) statusText = 'already uploaded to NYSCEF';

  return (
    <StableMuiDialog open={list.length > 0} onClose={() => close(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Delete and vacate stipulation?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`This will delete and vacate the stipulation, which was ${statusText}.`}
        </DialogContentText>
        {list.map((row) => (
          <Typography key={`${row.parcelId}-${row.stage}-${row.caseType}`} variant="body2" sx={{ mt: 1 }}>
            {`${row.address || row.parcelId} (${row.stage} ${row.caseType}) is ${vacatePhrase(row.status)}.`}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close(false)}>Cancel</Button>
        <Button onClick={() => close(true)} color="error" variant="contained">Delete and vacate</Button>
      </DialogActions>
    </StableMuiDialog>
  );
};

export default VacateStipDialog;
